import { render } from "./MachineWaterVends.vue?vue&type=template&id=db53fb38"
import script from "./MachineWaterVends.vue?vue&type=script&lang=js"
export * from "./MachineWaterVends.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__